import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "left" };
const _hoisted_3 = { class: "hub" };
const _hoisted_4 = { class: "worker" };
const _hoisted_5 = { class: "search" };
const _hoisted_6 = { class: "refresh" };
const _hoisted_7 = { class: "right" };
import { computed, onMounted, } from 'vue';
import vuexStore from '@/vuex-store';
import { i18n } from '@/locales';
import InputRow from '@/components/Form/InputRow.vue';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { autoLcCommon as initAutoLc } from '@/locales/ko/common';
import { BusinessError } from '@/error';
import { pStore } from '@/pinia';
import { orderEvent } from '@/constants';
import { useWorkerAllocate } from '@/use/useWorkerAllocate';
import { getFormValueForPinia, setFormValueForPinia, } from '@/utils/form';
import { userGetterType } from '@/vuex-store/user/getters';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerAllocateHeader',
    setup(__props) {
        // 라이더 배차 해더
        const lcCommon = initAutoLc();
        const pWorkerAllocateDialog = pStore.piniaWorkerAllocate;
        const { filterOption, hubList, popupId, selectedWorker, getHubList, selectedOrder, hubId, distId, } = useWorkerAllocate();
        const getFormValue = (key) => getFormValueForPinia(filterOption, key);
        const setFormValue = (key, value) => setFormValueForPinia(filterOption, key, value);
        const setFormValueForSelectedHub = (key, value) => {
            let _value = value;
            if (_value === null) {
                _value = hubList.value[0].value;
            }
            setFormValueForPinia(filterOption, key, _value);
        };
        // 기능: 필터링
        // 기능: 배차
        /**
         * 배차 이벤트 실행
         */
        const actionAllocateEvent = async (type) => {
            /** 팝업 자동 닫힘 시간 */
            const closeTime = 1000;
            let message = '';
            switch (type) {
                case orderEvent.WORKER_REQUEST:
                    message = 'success_request';
                    break;
                case orderEvent.ALLOCATE:
                    message = 'success_allocate';
                    break;
                case orderEvent.REALLOCATE:
                    message = 'success_reallocate';
                    break;
                default:
                    break;
            }
            try {
                await pWorkerAllocateDialog.actionAllocate(type);
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t(`common.${message}`));
                // 성공 후 팝업 닫기
                setTimeout(() => {
                    if (window.opener) {
                        window.opener[popupId].open = false;
                        window.opener[popupId].close();
                    }
                    else {
                        window[popupId].open = false;
                        window.close();
                    }
                }, closeTime);
            }
            catch (error) {
                if (error instanceof BusinessError) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message);
                }
            }
        };
        const isShareOrder = computed(() => {
            if (!hubId.value) {
                console.log('[setShareOrder] invalid parameter');
                return true;
            }
            if (!selectedWorker.value) {
                return true;
            }
            // 총판이 다르면 배요 불가
            if (distId.value !== selectedOrder.value?.distributorId) {
                return true;
            }
            if (selectedOrder.value?.isAddressBaseOrder()) {
                return false;
            }
            if (selectedOrder.value?.isB2B()) {
                return false;
            }
            // 총판 계정일 경우엔 총판 비교
            if (vuexStore.getters[userGetterType.isHead]
                && distId.value !== selectedOrder.value?.distributorId) {
                return true;
            }
            // 총판 계정이 아닐 때만 허브아이디 비교
            // 공유주문은 배요 불가 true는 버튼 비활성 됨
            if (!vuexStore.getters[userGetterType.isHead]
                && hubId.value !== selectedOrder.value?.hubId) {
                return true;
            }
            return false;
        });
        /**
         * 배차 요청 클릭 핸들러
         */
        const handleClickAllocateRequestBtn = async () => {
            actionAllocateEvent(orderEvent.WORKER_REQUEST);
        };
        /**
         * 즉시 배차 클릭 핸들러
         */
        const handleClickImmedateAllocateBtn = async () => {
            actionAllocateEvent(orderEvent.ALLOCATE);
        };
        /**
         * 재배차 클릭 핸들러
         */
        const handleClickReallocateBtn = async () => {
            actionAllocateEvent(orderEvent.REALLOCATE);
        };
        /**
         * 검색 클릭 핸들러
         */
        const handleClickSearchBtn = async () => {
            // 1. 검색어 추가 및 조회 셋팅
            pWorkerAllocateDialog.updateFilteredItemList();
        };
        /**
         * 새로고침 클릭 핸들러
         */
        const handleClickRefreshBtn = async () => {
            pWorkerAllocateDialog.resetFilterOption();
        };
        onMounted(async () => {
            await getHubList();
        });
        return (_ctx, _cache) => {
            const _component_v_autocomplete = _resolveComponent("v-autocomplete");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            "input-row-class": "",
                            label: "허브명"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_autocomplete, {
                                    placeholder: "허브명 검색",
                                    density: "compact",
                                    variant: "outlined",
                                    "item-title": "text",
                                    "item-value": "value",
                                    "hide-details": "",
                                    items: _unref(hubList),
                                    "model-value": getFormValue('selectedHub'),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValueForSelectedHub('selectedHub', value))
                                }, null, 8 /* PROPS */, ["items", "model-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(InputRow, {
                            "is-vertical-label": "",
                            "input-row-class": "",
                            label: "라이더명"
                        }, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 필터 "),
                                _createVNode(_component_v_text_field, {
                                    density: "comfortable",
                                    variant: "outlined",
                                    "hide-details": "",
                                    "model-value": getFormValue('searchText'),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => setFormValue('searchText', value)),
                                    onKeydown: _withKeys(handleClickSearchBtn, ["enter"])
                                }, null, 8 /* PROPS */, ["model-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_v_btn, {
                            class: "brg-btn info outlined size-l width-fill",
                            onClick: handleClickSearchBtn
                        }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" 검색 ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [2]
                        })
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_v_btn, {
                            class: "brg-btn info outlined size-l width-fill",
                            onClick: handleClickRefreshBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("mdi-restart")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [3]
                                })
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createCommentVNode(" 배요 "),
                    _createVNode(_component_v_btn, {
                        class: "brg-btn primary outlined size-l",
                        onClick: handleClickAllocateRequestBtn,
                        disabled: isShareOrder.value
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lcCommon)('worker_requested')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"]),
                    _createCommentVNode(" 즉배 "),
                    _createVNode(_component_v_btn, {
                        class: "brg-btn primary outlined size-l",
                        onClick: handleClickImmedateAllocateBtn,
                        disabled: _unref(selectedWorker) ? false : true
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lcCommon)('immediate_allocate')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"]),
                    _createCommentVNode(" 재배 "),
                    _createVNode(_component_v_btn, {
                        class: "brg-btn primary outlined size-l",
                        onClick: handleClickReallocateBtn,
                        disabled: _unref(selectedWorker) ? false : true
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(lcCommon)('reallocated')), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["disabled"])
                ])
            ]));
        };
    }
});
